import React, { useRef, useEffect } from "react";
import { twClassNames } from "../helpers/twClassNames";
import { uniqueId } from "lodash";
import { TooltipContainer } from "./Tooltip.jsx";

type CheckboxProps = {
    checked: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    label?: React.ReactNode;
    labelTooltip?: string;
    description?: string;
    descriptionPosition?: "below" | "inline";
    className?: string;
    indeterminate?: boolean;
};

export default function CheckBox({
    checked,
    onChange,
    disabled,
    label,
    labelTooltip,
    description,
    descriptionPosition = "below",
    className,
    indeterminate = false
}: CheckboxProps) {
    const labelStyles = twClassNames(
        "flex",
        descriptionPosition === "below" ? "flex-col gap-1" : "gap-2"
    );
    const id = uniqueId();
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    return (
        <div className={twClassNames("checkbox-container group relative", className)}>
            <input
                ref={inputRef}
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            {label &&
                (labelTooltip ? (
                    <TooltipContainer
                        body={labelTooltip}
                        placement="top"
                        customButton={
                            <label htmlFor={id} className={labelStyles}>
                                <span className={description ? "font-semibold" : "font-medium"}>
                                    {label}
                                </span>
                                {description && (
                                    <span className="font-normal text-gray-500">{description}</span>
                                )}
                            </label>
                        }
                    />
                ) : (
                    <label htmlFor={id} className={labelStyles}>
                        <span className={description ? "font-semibold" : "font-medium"}>
                            {label}
                        </span>
                        {description && (
                            <span className="font-normal text-gray-500">{description}</span>
                        )}
                    </label>
                ))}
        </div>
    );
}
